import axios from '@/framework/router/axios'

const apiProcAdd = (postdata) => {
  return axios.post('/flow-simple/proc', postdata)
}

const apiProcEdit = (postdata) => {
  return axios.put('/flow-simple/proc', postdata)
}

const apiProcDel = (id) => {
  return axios.delete(`/flow-simple/proc/${id}`)
}

const apiProcModelGet = (params) => {
  return axios.get('/flow-simple/proc/model', {
    params
  })
}

const apiProcModelSave = (postdata) => {
  return axios.post('/flow-simple/proc/model-save', postdata)
}

const apiProcModelImport = (postdata) => {
  return axios.post('/flow-simple/proc/model-import', postdata)
}

const apiProcModelPublish = (procId) => {
  return axios.put('/flow-simple/converter/release', null, { params: { procId }})
}

const apiProcModelMode2 = (procId) => {
  return axios.put('/flow-simple/converter/to-flow-able', null, { params: { procId }})
}

export default {
  apiProcAdd,
  apiProcEdit,
  apiProcDel,
  apiProcModelGet,
  apiProcModelSave,
  apiProcModelImport,
  apiProcModelPublish,
  apiProcModelMode2
}
